module.exports = __webpack_public_path__ + "static/pp_autouzupelnianie-71b120281bedf4e777626dcc809af3c4.gif";